<template>
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.0789 0.68579C24.123 1.5893 24.2369 3.1681 23.3334 4.21215L11.7949 17.5455L10.0696 19.5392L8.17042 17.7103L1.24734 11.0437C0.252789 10.086 0.222928 8.50333 1.18065 7.50878C2.13837 6.51422 3.721 6.48436 4.71555 7.44208L9.73943 12.2799L19.5526 0.94027C20.4561 -0.103781 22.0349 -0.217716 23.0789 0.68579Z"
      fill="white"
    />
  </svg>
</template>
